// Correctly type the Tanzania GeoJSON data
export const tanzaniaRegions: GeoJSON.FeatureCollection = {
  type: "FeatureCollection", // Ici le type est explicitement défini comme "FeatureCollection"
  features: [
    {
      type: "Feature",
      properties: { name: "Arusha", id: "arusha" },
      geometry: { type: "Point", coordinates: [36.683, -3.3869] },
    },
    {
      type: "Feature",
      properties: { name: "Dar es Salaam", id: "dar-es-salam" },
      geometry: { type: "Point", coordinates: [39.2083, -6.7924] },
    },
    {
      type: "Feature",
      properties: { name: "Dodoma", id: "dodoma" },
      geometry: { type: "Point", coordinates: [35.7382, -6.163] },
    },
    {
      type: "Feature",
      properties: { name: "Geita", id: "geita" },
      geometry: { type: "Point", coordinates: [32.2359, -2.8736] },
    },
    {
      type: "Feature",
      properties: { name: "Iringa", id: "iringa" },
      geometry: { type: "Point", coordinates: [35.7, -7.7667] },
    },
    {
      type: "Feature",
      properties: { name: "Kagera", id: "kagera" },
      geometry: { type: "Point", coordinates: [31.5, -1.8333] },
    },
    {
      type: "Feature",
      properties: { name: "Katavi", id: "katavi" },
      geometry: { type: "Point", coordinates: [31.8667, -6.9167] },
    },
    {
      type: "Feature",
      properties: { name: "Kigoma", id: "kigoma" },
      geometry: { type: "Point", coordinates: [29.6267, -4.8769] },
    },
    {
      type: "Feature",
      properties: { name: "Kilimanjaro", id: "kilimanjaro" },
      geometry: { type: "Point", coordinates: [37.3333, -3.0667] },
    },
    {
      type: "Feature",
      properties: { name: "Kusini Pemba", id: "kusini_pemba" },
      geometry: { type: "Point", coordinates: [39.8, -5.3] },
    },
    {
      type: "Feature",
      properties: { name: "Kaskazini Pemba", id: "kaskazini_pemba" },
      geometry: { type: "Point", coordinates: [39.7, -5.0] },
    },
    {
      type: "Feature",
      properties: { name: "Kusini Unguja", id: "kusini_unguja" },
      geometry: { type: "Point", coordinates: [39.2, -6.2] },
    },
    {
      type: "Feature",
      properties: { name: "Kaskazini Unguja", id: "kaskazini_unguja" },
      geometry: { type: "Point", coordinates: [39.3, -5.9] },
    },
    {
      type: "Feature",
      properties: { name: "Mjini Magharibi", id: "mjini_magharibi" },
      geometry: { type: "Point", coordinates: [39.2, -6.1] },
    },
    {
      type: "Feature",
      properties: { name: "Lindi", id: "lindi" },
      geometry: { type: "Point", coordinates: [39.7, -10.0] },
    },
    {
      type: "Feature",
      properties: { name: "Manyara", id: "manyara" },
      geometry: { type: "Point", coordinates: [36.5, -4.5] },
    },
    {
      type: "Feature",
      properties: { name: "Mara", id: "mara" },
      geometry: { type: "Point", coordinates: [33.9, -1.65] },
    },
    {
      type: "Feature",
      properties: { name: "Mbeya", id: "mbeya" },
      geometry: { type: "Point", coordinates: [33.4607, -8.9] },
    },
    {
      type: "Feature",
      properties: { name: "Morogoro", id: "morogoro" },
      geometry: { type: "Point", coordinates: [37.0, -7.0] },
    },
    {
      type: "Feature",
      properties: { name: "Mtwara", id: "mtwara" },
      geometry: { type: "Point", coordinates: [40.1833, -10.2667] },
    },
    {
      type: "Feature",
      properties: { name: "Mwanza", id: "mwanza" },
      geometry: { type: "Point", coordinates: [32.9174, -2.5164] },
    },
    {
      type: "Feature",
      properties: { name: "Njombe", id: "njombe" },
      geometry: { type: "Point", coordinates: [34.7667, -9.3333] },
    },
    {
      type: "Feature",
      properties: { name: "Pwani", id: "pwani" },
      geometry: { type: "Point", coordinates: [38.9333, -7.3333] },
    },
    {
      type: "Feature",
      properties: { name: "Rukwa", id: "rukwa" },
      geometry: { type: "Point", coordinates: [31.5, -7.5] },
    },
    {
      type: "Feature",
      properties: { name: "Ruvuma", id: "ruvuma" },
      geometry: { type: "Point", coordinates: [36.65, -10.6833] },
    },
    {
      type: "Feature",
      properties: { name: "Shinyanga", id: "shinyanga" },
      geometry: { type: "Point", coordinates: [33.4167, -3.6667] },
    },
    {
      type: "Feature",
      properties: { name: "Simiyu", id: "simiyu" },
      geometry: { type: "Point", coordinates: [34.5, -2.8333] },
    },
    {
      type: "Feature",
      properties: { name: "Singida", id: "singida" },
      geometry: { type: "Point", coordinates: [34.75, -5.4167] },
    },
    {
      type: "Feature",
      properties: { name: "Songwe", id: "songwe" },
      geometry: { type: "Point", coordinates: [32.8167, -9.0] },
    },
    {
      type: "Feature",
      properties: { name: "Tabora", id: "tabora" },
      geometry: { type: "Point", coordinates: [32.8, -5.0167] },
    },
    {
      type: "Feature",
      properties: { name: "Tanga", id: "tanga" },
      geometry: { type: "Point", coordinates: [39.0977, -5.0705] },
    },
  ],
};

export const TZRegions = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        name: "Arusha",
        id: "arusha",
        bbox: [
          34.74926160000009, -4.148158486999975, 37.429371975000045,
          -1.686906738999927,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [36.24497337924853, -3.3254955357747775],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dar-es-salaam",
        id: "dar-es-salaam",
        bbox: [
          39.00629042200003, -7.179418802999938, 39.552885593,
          -6.564077243999933,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [39.19015534972143, -6.891476464410785],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Dodoma",
        id: "dodoma",
        bbox: [
          35.052729991000014, -7.377303361999943, 36.96399683300011,
          -4.312734743999968,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [35.941968187074636, -6.05215194730426],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Geita",
        id: "geita",
        bbox: [
          31.149675821000116, -4.469111579999929, 32.79292654900005,
          -2.237866682999911,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [31.898638137819837, -2.8618055026120444],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Iringa",
        id: "iringa",
        bbox: [
          34.193339037, -9.040651407999977, 36.84481146700002,
          -6.886497098999922,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [35.30994714098912, -7.934154872903391],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kagera",
        id: "kagera",
        bbox: [
          30.410673738000032, -3.360234204999923, 32.617735121000074,
          -0.983143016999943,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [31.490190830285062, -1.97904633234455],
      },
    },
    // {
    //   type: "Feature",
    //   properties: {
    //     name: "Kaskazini Pemba",
    //     id: "kaskazini pemba",
    //     bbox: [
    //       39.630090539000015, -5.208608389999914, 39.8761988370001,
    //       -4.864377753999982,
    //     ],
    //   },
    //   geometry: {
    //     type: "Point",
    //     coordinates: [39.75370393574548, -5.042488383413406],
    //   },
    // },
    // {
    //   type: "Feature",
    //   properties: {
    //     name: "Kaskazini Unguja",
    //     id: "kaskazini unguja",
    //     bbox: [
    //       39.181401065000074, -6.040009479999953, 39.401206595000076,
    //       -5.721896821,
    //     ],
    //   },
    //   geometry: {
    //     type: "Point",
    //     coordinates: [39.26414174907969, -5.856335474346858],
    //   },
    // },
    {
      type: "Feature",
      properties: {
        name: "Katavi",
        id: "katavi",
        bbox: [
          29.90300115400008, -7.611911238999903, 32.758813014000026,
          -5.13337665200001,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [31.311066075311484, -6.279528105251025],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kigoma",
        id: "kigoma",
        bbox: [
          29.589529258000063, -6.570679089999943, 31.492551268000096,
          -2.82797489799994,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [30.353413762486717, -4.598359807189111],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Kilimanjaro",
        id: "kilimanjaro",
        bbox: [
          36.889584966, -4.613710212999955, 38.40360513100005,
          -2.849522467999954,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [37.36837629946625, -3.670394464104567],
      },
    },
    // {
    //   type: "Feature",
    //   properties: {
    //     name: "Kusini Pemba",
    //     id: "kusini pemba",
    //     bbox: [
    //       39.562709637000076, -5.487027136999967, 39.855784019000026,
    //       -5.158530313999965,
    //     ],
    //   },
    //   geometry: {
    //     type: "Point",
    //     coordinates: [39.69984535752483, -5.356550050819109],
    //   },
    // },
    // {
    //   type: "Feature",
    //   properties: {
    //     name: "Kusini Unguja",
    //     id: "kusini unguja",
    //     bbox: [
    //       39.26907116200009, -6.478158268999946, 39.580349143000035,
    //       -6.021440910999954,
    //     ],
    //   },
    //   geometry: {
    //     type: "Point",
    //     coordinates: [39.43088050601051, -6.258244508731392],
    //   },
    // },
    {
      type: "Feature",
      properties: {
        name: "Lindi",
        id: "lindi",
        bbox: [
          36.868123328, -10.735824916, 39.979933069000026, -7.932525213999953,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [39.28005207139243, -9.42731291743861],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Manyara",
        id: "manyara",
        bbox: [
          34.86441018500003, -5.951309147999962, 38.00005383000006,
          -3.448487107999931,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [36.735688733395634, -4.3251426030952],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Mara",
        id: "mara",
        bbox: [
          33.20293235800002, -2.498290962999949, 35.26591682400004,
          -1.026220874999961,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [33.78486173376181, -1.609901265075803],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Mbeya",
        id: "mbeya",
        bbox: [
          32.89372180000007, -9.718721595000014, 34.96806732800006,
          -6.865109711999929,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [33.718001178555525, -8.764792980457273],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Mjini Magharibi",
        id: "mjini magharibi",
        bbox: [
          39.18558780400009, -6.321642680999962, 39.309956528000065,
          -6.027276066999943,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [39.248176202742314, -6.182150038129635],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Morogoro",
        id: "morogoro",
        bbox: [
          35.32325800600009, -9.92163121199995, 38.51574233400005,
          -5.800068949000015,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [36.895684116151344, -7.9579331726304146],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Mtwara",
        id: "mtwara",
        bbox: [
          37.999048110000075, -11.417695679999985, 40.44473482300003,
          -10.125081371999935,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [39.42004713143478, -10.539824957720988],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Mwanza",
        id: "mwanza",
        bbox: [
          31.932809830000036, -3.435410028, 33.78980878000008,
          -1.667174498999923,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [32.66341767766988, -2.435604281990282],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Njombe",
        id: "njombe",
        bbox: [
          33.81097343700003, -10.538402826999972, 35.52316866300004,
          -8.663164352999974,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [34.623370788459965, -9.599319991428382],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Pwani",
        id: "pwani",
        bbox: [
          37.7941382010001, -8.51251862399992, 39.90845002400005,
          -5.841272914999974,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [39.25499934188102, -7.757404953850726],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Rukwa",
        id: "rukwa",
        bbox: [
          30.499380149000082, -9.073341859999939, 32.453775785000055,
          -6.884823308999988,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [31.20892114302243, -7.870666011590095],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Ruvuma",
        id: "ruvuma",
        bbox: [
          34.56859610900007, -11.762349213999913, 38.112979012999986,
          -9.248488052,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [35.99379476256799, -10.461563915490967],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Shinyanga",
        id: "shinyanga",
        bbox: [
          31.682261485000012, -4.324300071999964, 34.23357538600002,
          -3.195401912999973,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [33.10483855238141, -3.7721306548539872],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Simiyu",
        id: "simiyu",
        bbox: [
          33.42307385600002, -4.084632605999971, 35.22343687700002,
          -2.17863263600001,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [33.98183928900959, -3.0214788958440524],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Singida",
        id: "singida",
        bbox: [
          33.486548789000075, -7.534773215999924, 35.356383491000074,
          -3.800775858999927,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [34.57302503188352, -5.535012608386303],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Songwe",
        id: "songwe",
        bbox: [
          32.02000833700002, -9.62397844, 33.690104316000074,
          -6.925584645999916,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [32.916890331241724, -8.770302331825597],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Tabora",
        id: "tabora",
        bbox: [
          31.03801739900011, -6.976729138999905, 34.24203805300007,
          -3.876683971999928,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [32.880167659710246, -5.007427502228623],
      },
    },
    {
      type: "Feature",
      properties: {
        name: "Tanga",
        id: "tanga",
        bbox: [
          37.018945653000095, -6.019738437999956, 39.22005592600006,
          -4.108689806999976,
        ],
      },
      geometry: {
        type: "Point",
        coordinates: [38.55425443038109, -5.303947184637827],
      },
    },
  ],
};

// console.log(
//   TZRegions.features.reduce((acc, prev) => {
//     acc[prev.properties.id] = prev.properties;
//     return acc;
//   }, {} as { [key: string]: any })
// );
